<template>
	<div @click.self="$emit('close')" class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-20">
		<div class="popup-bg text-[var(--popup-text-color)] rounded-lg p-8 w-10/12 md:w-3/6 lg:w-1/3 xl:w-1/4 relative brightness-110">
			<button @click="$emit('close')" class="absolute top-4 right-4">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close Icon" class="w-3 h-3"/>
			</button>
			<h2 class="text-2xl font-archivomedium md:mb-8 mb-4 text-center text-[var(--popup-text-color)]">
				Cardware Resources
			</h2>
			<div class="flex flex-row justify-around items-center space-x-2 md:space-x-4">
				<a href="https://docs.cardwarewallet.com/" target="_blank" rel="noopener noreferrer" class="flex flex-col items-center justify-center cursor-pointer rounded-lg p-4 hover:bg-[var(--accent-color)] transition duration-200 ease-in-out">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkDocs : lightDocs" alt="Docs Icon" class="w-10 h-10 md:w-12 md:h-12 mb-2"/>
					<span class="text-md font-archivoregular text-[var(--secondary-text-color)] hover:underline">
						Docs
					</span>
				</a>
				<a href="https://docs.cardwarewallet.com/cardware-wallet-documentation/getting-started" target="_blank" rel="noopener noreferrer" class="flex flex-col items-center justify-center cursor-pointer rounded-lg p-4 hover:bg-[var(--accent-color)] transition duration-100 ease-in-out">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkGuide : lightGuide" alt="Guides Icon" class="w-10 h-10 md:w-12 md:h-12 mb-2"/>
					<span class="text-md font-archivoregular text-[var(--secondary-text-color)] hover:underline">
						Guide
					</span>
				</a>
				<a href="https://docs.cardwarewallet.com/resources/faqs" target="_blank" rel="noopener noreferrer" class="flex flex-col items-center justify-center cursor-pointer rounded-lg p-4 hover:bg-[var(--accent-color)] transition duration-200 ease-in-out">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkFAQs : lightFAQs" alt="FAQs Icon" class="w-10 h-10 md:w-12 md:h-12 mb-2"/>
					<span class="text-md font-archivoregular text-[var(--secondary-text-color)] hover:underline">
						FAQs
					</span>
				</a>
			</div>
		</div>
	</div>
</template>

<script setup>
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';
	import lightDocs from '../assets/Docs_Light_Theme.png';
	import darkDocs from '../assets/Docs_Dark_Theme.png';
	import lightGuide from '../assets/Guide_Light_Theme.png';
	import darkGuide from '../assets/Guide_Dark_Theme.png';
	import lightFAQs from '../assets/FAQs_Light_Theme.png';
	import darkFAQs from '../assets/FAQs_Dark_Theme.png';

	const props = defineProps({
		currentTheme: { type: String, required: true }
	});

	const emit = defineEmits(['close']);
</script>

<style scoped>
	.popup-bg {
		background: var(--popup-bg-color);
	}
</style>
